import { render, staticRenderFns } from "./BottomPanel.vue?vue&type=template&id=2518ab80&scoped=true&"
import script from "./BottomPanel.vue?vue&type=script&lang=js&"
export * from "./BottomPanel.vue?vue&type=script&lang=js&"
import style0 from "./BottomPanel.vue?vue&type=style&index=0&id=2518ab80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2518ab80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
